import React, { Fragment } from 'react'

import { ContentLoader } from 'components/_new/ui'


export type ContentWithLoaderProps = {
  className?: string
  isFetching?: boolean
  fullHeight?: boolean
}

const ContentWithLoader: React.FunctionComponent<ContentWithLoaderProps> = (props) => {
  const { children, className, fullHeight, isFetching } = props

  return isFetching ? (
    <ContentLoader className={className} fullHeight={fullHeight} />
  ) : (
    <Fragment>
      {children}
    </Fragment>
  )
}


export default ContentWithLoader
